import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    getCoupons,
    getCompanies,
    createCoupon,
} from "../../../Servicefile/couponService.jsx";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Couponsdata = () => {
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [customerSearch, setCustomerSearch] = useState("");
    const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
    const { showLoader, hideLoader } = useLoader();
    const [formData, setFormData] = useState({
        code: "",
        discountAmount: "",
        isActive: true,
        customerId: "",
        usageType: "CAMPAIGN",
        usageLimit: "",
    });
    useEffect(() => {
        fetchCustomers();
    }, []);
    useEffect(() => {
        fetchCoupons();
    }, []);
    const fetchCustomers = async () => {
        try {
            showLoader();

            const data = await getCompanies();

            const filteredCustomers = (data || []).filter(
                (item) =>
                    item.parentId === null ||
                    item.parentId === 0 ||
                    item.parentId === undefined
            );

            setCustomers(filteredCustomers);

        } catch (error) {
            console.error(
                "Fetch Customers Error:",
                error
            );
        } finally {
            hideLoader();
        }
    };

    const fetchCoupons = async () => {

        try {
            showLoader();
            setLoading(true);

            const data =
                await getCoupons();

            setCoupons(data || []);

        } catch (error) {

            console.error(
                "Fetch Coupons Error:",
                error
            );

        } finally {

            setLoading(false);
            hideLoader();
        }
    };

    const handleChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleCreateCoupon = async () => {

        try {
            showLoader();

            const payload = {
                code: formData.code,
                discountAmount: Number(
                    formData.discountAmount
                ),
                isActive: formData.isActive,
                customerId:
                    formData.customerId,
                usageType:
                    formData.usageType,
                usageLimit: Number(
                    formData.usageLimit
                ),
            };

            await createCoupon(payload);

            alert(
                "Coupon Created Successfully"
            );

            setShowPopup(false);

            setFormData({
                code: "",
                discountAmount: "",
                isActive: true,
                customerId: "",
                usageType: "CAMPAIGN",
                usageLimit: "",
            });

            setCustomerSearch("");

            fetchCoupons();

        } catch (error) {

            console.error(
                "Create Coupon Error:",
                error
            );

            alert(
                "Failed to create coupon"
            );
        } finally {
            hideLoader();
        }
    };

    return (
        <div style={containerStyle}>
            {/* Top Section */}
            <div style={topBarStyle}>


                <button
                    style={createButtonStyle}
                    onClick={() =>
                        setShowPopup(true)
                    }
                >
                    Create Coupon
                </button>
            </div>

            {/* Table */}
            <div style={tableWrapperStyle}>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>
                                Coupon Code
                            </th>
                            <th style={thStyle}>
                                Discount Amount
                            </th>
                            <th style={thStyle}>
                                Active
                            </th>
                            <th style={thStyle}>
                                Customer Id
                            </th>
                            <th style={thStyle}>
                                Usage Type
                            </th>
                            <th style={thStyle}>
                                Usage Limit
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {coupons.length > 0 ? (
                            coupons.map(
                                (
                                    item,
                                    index
                                ) => (
                                    <tr
                                        key={
                                            index
                                        }
                                    >
                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.code
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.discountAmount
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {item.isActive
                                                ? "Yes"
                                                : "No"}
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.customerId
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.usageType
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.usageLimit
                                            }
                                        </td>
                                    </tr>
                                )
                            )
                        ) : (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{
                                        textAlign:
                                            "center",
                                        padding:
                                            "20px",
                                    }}
                                >
                                    {loading
                                        ? "Loading..."
                                        : "No Coupons Found"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Popup */}
            {showPopup && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(15, 23, 42, 0.55)",
                        backdropFilter: "blur(4px)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        padding: "20px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "760px",
                            background: "#ffffff",
                            borderRadius: "24px",
                            padding: "20px",
                            boxShadow:
                                "0 20px 45px rgba(0,0,0,0.18)",
                            border: "1px solid #e5e7eb",
                            animation: "popupFade 0.3s ease",
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                // marginBottom: "15px",
                            }}
                        >
                            <div>
                                <h2
                                    style={{
                                        margin: 0,
                                        fontSize: "26px",
                                        fontWeight: "700",
                                        color: "#111827",
                                    }}
                                >
                                    Create Coupon
                                </h2>

                                <p
                                    style={{
                                        marginTop: "6px",
                                        fontSize: "14px",
                                        color: "#6b7280",
                                    }}
                                >
                                    Create and manage coupon discounts
                                </p>
                            </div>

                            <button
                                onClick={() =>
                                    setShowPopup(false)
                                }
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "50%",
                                    border: "none",
                                    background: "#f3f4f6",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#374151",
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* FORM GRID */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns:
                                    "repeat(auto-fit, minmax(240px, 1fr))",
                                gap: "14px",
                            }}
                        >
                            {/* Coupon Code */}
                            <div>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#374151",
                                    }}
                                >
                                    Coupon Code
                                </label>

                                <input
                                    type="text"
                                    value={formData.code}
                                    onChange={(e) =>
                                        handleChange(
                                            "code",
                                            e.target.value
                                        )
                                    }
                                    placeholder="Enter coupon code"
                                    style={{
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "14px",
                                        border:
                                            "1.5px solid #d1d5db",
                                        padding: "0 14px",
                                        fontSize: "14px",
                                        outline: "none",
                                        transition: "0.2s",
                                        boxSizing: "border-box",
                                    }}
                                />
                            </div>

                            {/* Discount */}
                            <div>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#374151",
                                    }}
                                >
                                    Discount Amount
                                </label>

                                <input
                                    type="number"
                                    value={
                                        formData.discountAmount
                                    }
                                    onChange={(e) =>
                                        handleChange(
                                            "discountAmount",
                                            e.target.value
                                        )
                                    }
                                    placeholder="Enter amount"
                                    style={{
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "14px",
                                        border:
                                            "1.5px solid #d1d5db",
                                        padding: "0 14px",
                                        fontSize: "14px",
                                        outline: "none",
                                        boxSizing: "border-box",
                                    }}
                                />
                            </div>

                            {/* Customer ID */}
                            {/* Select Company */}
                            <div style={{ position: "relative" }}>

                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#374151",
                                    }}
                                >
                                    Select Company
                                </label>

                                <input
                                    type="text"
                                    value={customerSearch}
                                    onFocus={() =>
                                        setShowCompanyDropdown(true)
                                    }
                                    onChange={(e) => {

                                        setCustomerSearch(
                                            e.target.value
                                        );

                                        // ✅ Open dropdown while typing
                                        setShowCompanyDropdown(true);

                                        // ✅ Clear customerId if input cleared
                                        if (e.target.value === "") {
                                            handleChange(
                                                "customerId",
                                                ""
                                            );
                                        }
                                    }}
                                    placeholder="Search company name"
                                    style={{
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "14px",
                                        border: "1.5px solid #d1d5db",
                                        padding: "0 14px",
                                        fontSize: "14px",
                                        outline: "none",
                                        boxSizing: "border-box",
                                        background: "#fff",
                                    }}
                                />

                                {/* DROPDOWN */}
                                {showCompanyDropdown && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "75px",
                                            left: 0,
                                            right: 0,
                                            background: "#fff",
                                            border: "1px solid #e5e7eb",
                                            borderRadius: "12px",
                                            maxHeight: "220px",
                                            overflowY: "auto",
                                            zIndex: 999,
                                            boxShadow:
                                                "0 10px 25px rgba(0,0,0,0.12)",
                                        }}
                                    >

                                        {customers
                                            .filter((item) => {

                                                // ✅ Show all initially
                                                if (!customerSearch)
                                                    return true;

                                                // ✅ Filter while typing
                                                return item.companyName
                                                    ?.toLowerCase()
                                                    .includes(
                                                        customerSearch.toLowerCase()
                                                    );
                                            })
                                            .map((item) => (

                                                <div
                                                    key={item.vendorId}
                                                    onClick={() => {

                                                        // ✅ Show selected company in input
                                                        setCustomerSearch(
                                                            item.companyName
                                                        );

                                                        // ✅ Send referenceId as customerId
                                                        handleChange(
                                                            "customerId",
                                                            item.referenceId
                                                        );

                                                        // ✅ Close dropdown
                                                        setShowCompanyDropdown(false);
                                                    }}
                                                    style={{
                                                        padding: "12px 14px",
                                                        cursor: "pointer",
                                                        borderBottom:
                                                            "1px solid #f3f4f6",
                                                        transition: "0.2s",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background =
                                                            "#f9fafb";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background =
                                                            "#fff";
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                            color: "#111827",
                                                        }}
                                                    >
                                                        {item.companyName}
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            color: "#6b7280",
                                                            marginTop: "2px",
                                                        }}
                                                    >
                                                        {item.referenceId}
                                                    </div>

                                                </div>
                                            ))}

                                        {/* No Data */}
                                        {customers.filter((item) =>
                                            item.companyName
                                                ?.toLowerCase()
                                                .includes(
                                                    customerSearch.toLowerCase()
                                                )
                                        ).length === 0 && (
                                                <div
                                                    style={{
                                                        padding: "14px",
                                                        textAlign: "center",
                                                        color: "#6b7280",
                                                        fontSize: "13px",
                                                    }}
                                                >
                                                    No company found
                                                </div>
                                            )}

                                    </div>
                                )}
                            </div>
                            {/* Usage Type */}
                            <div>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#374151",
                                    }}
                                >
                                    Usage Type
                                </label>

                                <select
                                    value={formData.usageType}
                                    onChange={(e) =>
                                        handleChange(
                                            "usageType",
                                            e.target.value
                                        )
                                    }
                                    style={{
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "14px",
                                        border:
                                            "1.5px solid #d1d5db",
                                        padding: "0 14px",
                                        fontSize: "14px",
                                        outline: "none",
                                        background: "#fff",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <option value="CAMPAIGN">
                                        CAMPAIGN
                                    </option>

                                    <option value="SUBSCRIPTION">
                                        SUBSCRIPTION
                                    </option>
                                </select>
                            </div>

                            {/* Usage Limit */}
                            <div>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#374151",
                                    }}
                                >
                                    Usage Limit
                                </label>

                                <input
                                    type="number"
                                    value={formData.usageLimit}
                                    onChange={(e) =>
                                        handleChange(
                                            "usageLimit",
                                            e.target.value
                                        )
                                    }
                                    placeholder="Enter limit"
                                    style={{
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "14px",
                                        border:
                                            "1.5px solid #d1d5db",
                                        padding: "0 14px",
                                        fontSize: "14px",
                                        outline: "none",
                                        boxSizing: "border-box",
                                    }}
                                />
                            </div>
                        </div>

                        {/* BUTTONS */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "14px",
                                marginTop: "20px",
                            }}
                        >
                            <button
                                onClick={() =>
                                    setShowPopup(false)
                                }
                                style={{
                                    height: "46px",
                                    padding: "0 24px",
                                    borderRadius: "14px",
                                    border:
                                        "1px solid #d1d5db",
                                    background: "#f9fafb",
                                    color: "#374151",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    fontSize: "14px",
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={
                                    handleCreateCoupon
                                }
                                style={{
                                    height: "46px",
                                    padding: "0 28px",
                                    borderRadius: "14px",
                                    border: "none",
                                    background:
                                        "linear-gradient(135deg,#f97316,#ea580c)",
                                    color: "#fff",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    boxShadow:
                                        "0 10px 20px rgba(249,115,22,0.25)",
                                }}
                            >
                                Save Coupon
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const containerStyle = {
    padding: "20px",
    fontFamily:
        "Segoe UI, sans-serif",
};

const topBarStyle = {
    display: "flex",
    justifyContent:
        "space-between",
    alignItems: "center",
    marginBottom: "20px",
};

const createButtonStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "600",
};

const tableWrapperStyle = {
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: "10px",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
};

const thStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    padding: "14px",
    textAlign: "center",
    fontWeight: "600",
};

const tdStyle = {
    padding: "14px",
    textAlign: "center",
    borderBottom:
        "1px solid #ddd",
};

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
        "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999,
};

const popupStyle = {
    background: "#fff",
    width: "700px",
    borderRadius: "12px",
    padding: "25px",
};

const formGridStyle = {
    display: "grid",
    gridTemplateColumns:
        "repeat(2,1fr)",
    gap: "18px",
};

const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontWeight: "600",
    fontSize: "14px",
};

const inputStyle = {
    width: "100%",
    padding: "12px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    outline: "none",
};

const saveButtonStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
};

const cancelButtonStyle = {
    background: "#6b7280",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
};

export default Couponsdata;